import { render, staticRenderFns } from "./MobileScreenlet.vue?vue&type=template&id=f4601812&"
import script from "./MobileScreenlet.vue?vue&type=script&lang=js&"
export * from "./MobileScreenlet.vue?vue&type=script&lang=js&"
import style0 from "./MobileScreenlet.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports